import formatNumber from '@/shared/filters/format-number';

export const maskNumber = {
    bind(el, binding, node) {
        const keycodeAllow = [8, 9, 37, 38, 39, 40, 46];
        const regEx = new RegExp('^[0-9]*$');

        el.addEventListener('keydown', (e) => {
            if (!(regEx.test(e.key)
                || checkDotChar(e.keyCode, node.elm.value)
                || keycodeAllow.find((x: any) => x === e.keyCode))) {
                e.preventDefault();
            }

            return;
        });

        el.addEventListener('keyup', (e) => {
            if (e.keyCode !== 190) {
                transformData();
            }
        });

        const transformData = () => {
            const currentVal = node.elm.value.split(',').join('');
            const formatValue = formatNumber(currentVal, '0,0.[000000000000]');
            const event = new Event('input', {bubbles: true});

            node.elm.value = formatValue;
            el.dispatchEvent(event);
        };

        const findVModelName = (vnode: any) => {
            return vnode.data.directives.find((o) => {
                return o.name === 'model';
            }).expression;
        }

        const checkDotChar = (keyCode: number, preValue: string) => {
            if (keyCode === 190 && preValue.indexOf('.') < 0) {
                return true;
            }
            return false;
        };
    },
};
